import { render } from "./processing.vue?vue&type=template&id=bb528bce&scoped=true"
import script from "./processing.vue?vue&type=script&lang=js"
export * from "./processing.vue?vue&type=script&lang=js"

import "./processing.vue?vue&type=style&index=0&id=bb528bce&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb528bce"]])

export default __exports__